<template>
    <Box title="人员搜索">
        <div class="inputBox">
            <img src="../../assets/img/search.png"/>
            <input type="text" @input='inputvalue' placeholder="请输入姓名"/>
        </div>

        <div class="itemBox">
            <van-checkbox-group v-model='selected'>
              <van-checkbox class="items" v-for="(item,key) in AssignUserList" :name="item" :key='key'>{{item.UserName}}</van-checkbox>
            </van-checkbox-group>
        </div>
        <Footer button="添加" @change="change"/>
    </Box>
</template>

<script>
    import Vue from 'vue';
    import { Checkbox, CheckboxGroup } from 'vant';
    import Box from '../../components/commonBox/commonBox'
    import Footer from '../../components/footer/footer'
    Vue.use(Checkbox);
    Vue.use(CheckboxGroup);
    export default {
        name: 'StaffSearch',
        components: {
            Checkbox,
            CheckboxGroup,
            Box,
            Footer,
        },
        data() {
            return {
                AssignUserList:[],
                selected:[],
                outTime:0
            }
        },
        mounted(){
           this.loadDataDefault('');
        },
        methods: {
            loadDataDefault(inputValue){
              this.$get('api/Dispatch/GetRepaitUsers',{
                          QueryText:inputValue?inputValue:'',
                          UserCode:this.$UserInfo.UserId,
                          PageIndex:1,
                          PageSize:100,
                          Token:'123445'
                        }).then(result=>{
                            this.AssignUserList=result.AssignUserList;
                        })
            },
            change(){//页面返回维修工程师
            if(this.selected.length===0){
                this.$Toast('请选择维修工程师！');
                return false;
            }
            this.$Bus.$emit('selectStaff',this.selected)
            this.$router.back();
            },inputvalue(obj){
                let inputValue=obj.target.value;
                if (this.outTime == 0) {
                    this.outTime = setTimeout(() => {
                        this.loadDataDefault(inputValue);
                    }, 1500)
                } else {
                    clearTimeout(this.outTime)
                    this.outTime = setTimeout(() => {
                        this.loadDataDefault(inputValue);
                    }, 1500)
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .inputBox{
        height: 86px;
        display: flex;
        align-items: center;
        background: #369189;
        border-radius: 10px;
        padding: 0 30px;
        box-sizing: border-box;
        img{
            width: 30px;
        }
        input{
            margin-left: 26px;
            font-size: 29px;
            color: #fff;
            flex: 1;
            &::-webkit-input-placeholder{
                color: rgba(255,255,255,.35);
            }
        }
    }
    .itemBox{
        background: #fff;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 0 40px;
        margin-top: 20px;
        .items{
            height: 112px;
            border-bottom: 2px solid #f3f3f3;
            line-height: 112px;
            color: $TEXT-DARK-COLOR;
            font-size: 29px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/staffSearch/staffSearch.vue